import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { selectHypothesisFrame } from '../../../selectors/message';

const selectUnresolvedItems = (state: RootState) => state.unresolvedItems;

// Raw cumulative lists straight off the latest hypothesis frame (source of
// truth — the producer replaces these every event). Absent fields => empty.
const selectAllNotOnMenuCards = createSelector(
  selectHypothesisFrame,
  (frame) => frame?.data?.not_on_menu_cards ?? []
);

const selectAllInvalidOptionLines = createSelector(
  selectHypothesisFrame,
  (frame) => frame?.data?.invalid_option_lines ?? []
);

// Cards visible to the agent — empty when the panel has been dismissed.
const selectVisibleNotOnMenuCards = createSelector(
  selectAllNotOnMenuCards,
  selectUnresolvedItems,
  (cards, { allDismissed }) => (allDismissed ? [] : cards)
);

const selectVisibleInvalidOptionLines = createSelector(
  selectAllInvalidOptionLines,
  selectUnresolvedItems,
  (lines, { allDismissed }) => (allDismissed ? [] : lines)
);

const selectUnresolvedItemsCount = createSelector(
  selectVisibleNotOnMenuCards,
  selectVisibleInvalidOptionLines,
  (cards, lines) => cards.length + lines.length
);

export {
  selectAllNotOnMenuCards,
  selectAllInvalidOptionLines,
  selectVisibleNotOnMenuCards,
  selectVisibleInvalidOptionLines,
  selectUnresolvedItemsCount,
};
